import { ModalButtonSet } from '../contracts/modal-buttons';
import { IAction } from './action';

export class SetButtons implements IAction {
    constructor(public buttons: number) {}
}
